export enum EntryFlow {
  DEFAULT = "default",
  IMPORT_FILE = "import-file"
}
